<template>
  <div class="freshTalent" v-wechat-title="$route.meta.title">
    <Header/>
    <BannerBg/>
    <div class="home_main_box">
      <div class="site_width" id="about2">
        <div class="Practices_title">
            <h1>招贤纳士</h1>
            <span>Eglish</span>
        </div>
      </div>
      <div class="site_width"> 
        <div class="padding15">
          <div class="news_content honor_info"> 
            <p><span></span></p> 

            <p><span>天津金展律师事务所2013年成立，是一家以破产案件和商事诉讼为主要发展方向的专业性律师事务所，具备天津市一级破产管理人资质。金展团队成员为华融证券股份有限公司、天津津诚国有资本投资运营有限公司、天津市保税区建设和交通管理局、天津空港经济区规划和国土资源管理局、壳牌华北石油集团、狮桥融资租赁（中国）有限公司、南开大学及天津市国土资源和房屋管理局等大型政企单位提供法律服务。</span><br /></p>
            <p><br /></p>
            <p><span>授薪律师：</span><br /></p>
            <p><br /></p>
            <p><span>【岗位发展方向】</span><br /></p>
            <p>该岗位主要从事企业日常法律服务以及破产案件相关工作，包括从事破产管理人的各类非诉及相关诉讼工作、为债权人债务人申报企业破产、为战略投资人提供法律服务等。<br /></p>
            
            <p><span>【岗位要求】</span><br /></p>
            <p>1、毕业于名校；<br /></p>
            <p>2、有律师执业证书；<br /></p>
            <p>3、任劳任怨、有团队协作精神；<br /></p>
            <p>4、愿意投入到破产管理人事业者优先录取。<br /></p>
            
            <p><br /></p>
            <p><span>授薪诉讼律师：</span><br /></p>
            <p><br /></p>
            <p><span>【岗位发展方向】</span><br /></p>
            <p>主要从事商事诉讼、经济犯罪案及破产衍生诉讼案件工作。<br /></p>
            
            <p><span>【岗位要求】</span><br /></p>
            <p>1、毕业于名校；<br /></p>
            <p>2、有律师执业证书；<br /></p>
            <p>3、任劳任怨、有团队协作精神；<br /></p>
            <p>4、有金融资产管理公司、投资公司、银行及经济犯罪案服务经验者优先录取。<br /></p>

            <p><br /></p>
            <p><span>律师助理：</span><br /></p>
            <p><br /></p>
            <p><span>【岗位要求及工作内容】</span><br /></p>
            <p>1、法学本科以上学历；<br /></p>
            <p>2、熟悉各类办公软件；<br /></p>
            <p>3、吃苦耐劳、勤奋严谨；<br /></p>
            <p>4、协助律师处理各类非诉及诉讼各类工作。<br /></p>
            
            <p><br /></p>
            <p><br /></p>
            <p><span>有意者请将个人简历（注：附个人近期照片及应聘岗位）发至邮箱：zhangyue@lvshi.com.cn</span><br /></p>
            <p><span></span><br /></p> 
          </div> 
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
  export default {
    name: "freshTalent"
  }
</script>
<style scoped lang="less">
  .news_content p, .news_content span, .news_content font {
    font-size: 18px !important;
  }
</style>